import { createFileRoute } from '@tanstack/react-router'
import { WargaProfilPage } from '../../../../components/warga/WargaProfilPage'

export const Route = createFileRoute('/desa/$slug/warga/profil')({
  component: WargaProfilPage,
})
